import { isEmpty } from "lodash";
import DropdownInput from "../DropdownInput";
import React from "react";
import cx from "classnames";
import * as Helper from "../../utils/helper";
import "./DiagCartLoyaltyItem.scss";

const staticText = {
  cashbackText:
    "Cashback will be credited after sample collection of PLUS order",
  plusMembershipText: "PLUS Membership",
  plan: "plan",
};

const DiagCartLoyaltyItem = (props) => {
  const {
    diagLoyaltyItem,
    selectedLPVariant,
    removeLPItem,
    onLPVariantUpdate,
    programId,
  } = props;

  /**
   * delete function for the lp diag item
   */
  const handleDelete = () => {
    removeLPItem();
  };

  /**
   * The handleVariantChange function is designed to handle changes in the loyalty program variant selection.
   * It takes the selected variant's value as an argument, finds the corresponding variant object from the
   * diagLoyaltyItem's variants array using the variant's id,
   * and then calls the onLPVariantUpdate prop function, passing the programId and the selected variant object to it.
   * This updates the selected loyalty program variant in the parent component.
   */
  const handleVariantChange = (value) => {
    const selectedVariant = diagLoyaltyItem.variants.find(
      (variant) => variant.id === value.value
    );
    onLPVariantUpdate(programId, selectedVariant);
  };

  const selectedVariant = diagLoyaltyItem.variants.find(
    (variant) => variant.id === selectedLPVariant.id
  );
  const dropdownLabel = selectedVariant.duration.split(" ")[0] + " " + "M";

  return (
    <div
      className={cx("DiagCartLoyaltyListItem", {
        HasWarning: false,
        "pe-loading": false,
      })}
    >
      <div className="detailsContainer">
        <div className="medTypeIconGroup">
          <img
            src="https://assets.pharmeasy.in/web-assets/images/ooc-lp-icon.svg"
            alt="lp-icon"
          />
        </div>
        {selectedLPVariant.duration && (
          <div className="MedName">
            <div>
              {`${staticText.plusMembershipText} - ${
                selectedVariant ? selectedVariant.duration : ""
              } ${staticText.plan}`}
            </div>
          </div>
        )}
        <div className="MedAvailability" />
        <div className="MedPack" />
        <div className="LoyaltyQty">
          <DropdownInput
            options={Helper.createDiagLoyaltyVariantsArray(
              diagLoyaltyItem.variants
            )}
            onSelect={handleVariantChange}
            value={{
              label: dropdownLabel,
              value: selectedVariant.id,
            }}
            className="cartLoyaltyQty"
          />
        </div>
        <div className="LoyaltyPrice">
          {selectedVariant.amount && (
            <div className="mrPrice">₹{selectedVariant.amount}</div>
          )}
          {selectedVariant.discounted_amount && (
            <div className="pePrice">₹{selectedVariant.discounted_amount}</div>
          )}
        </div>
        <button
          className={`MedRemove ${props.isDeleting ? "processing" : ""}`}
          onClick={handleDelete}
        >
          <img src={require("../../images/remove.svg")} alt="x" />
        </button>
      </div>
      {!isEmpty(diagLoyaltyItem.flash_message) && (
        <div className="extraDetailsContainer">
          <div className="saveExtraText">{diagLoyaltyItem.flash_message}</div>
          <div className="subtext">{staticText.cashbackText}</div>
        </div>
      )}
    </div>
  );
};

export default DiagCartLoyaltyItem;
